// Multilingual translations - All Major Indian Languages
// Supports: English, Hindi, Bengali, Telugu, Marathi, Tamil, Gujarati, Kannada, Malayalam, Punjabi, Odia

export const LANGUAGES = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
    { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
    { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
    { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
    { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
    { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી' },
    { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
    { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
    { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' },
    { code: 'or', name: 'Odia', nativeName: 'ଓଡ଼ିଆ' },
];

export const TRANSLATIONS = {
    en: {
        dashboard: 'Dashboard',
        quick_actions: 'Quick Actions',
        system_features: 'System Features',
        govt_schemes: 'Active Government Schemes',
        apply_now: 'Apply Now',
        learn_more: 'Learn More',
        select_state: 'Select State',
        all_india: 'All India',
        register_farmer: 'Register New Farmer',
        recent_farmers: 'Recent Farmers',

        // Features
        iot_integration: 'IoT Integration',
        iot_integration_desc: 'Real-time soil sensors',
        ml_recommendations: 'ML Recommendations',
        ml_recommendations_desc: 'AI-powered fertilizer suggestions',
        soil_health_cards: 'Soil Health Cards',
        soil_health_cards_desc: 'Government-verified reports',
        dealer_locator: 'Dealer Locator',
        dealer_locator_desc: 'Find nearest fertilizer shops',
        subsidy_calc: 'Subsidy Calculator',
        subsidy_calc_desc: 'Calculate government subsidies',
        govt_integration: 'Govt. Schemes',
        govt_integration_desc: 'Govt. of India Soil Health Card Standards',
        multi_dataset: 'Multi-Dataset AI',
        multi_dataset_desc: 'Training on 30,000+ pan-India samples',
        coming_soon: 'Coming Soon',

        // New Pages
        farmer: 'Farmer',
        crop: 'Crop',
        soil_data_entry: 'Soil Data Entry',
        back_dashboard: 'Back to Dashboard',
        manual_entry: 'Manual Entry',
        upload_file: 'Upload File',
        submit_generate: 'Submit & Generate Recommendations',
        drag_drop: 'Drag & Drop or Click to Upload',
        drop_file: 'Drop file here',
        uploading: 'Uploading',
        failed_load_farmer: 'Failed to load farmer details',
        failed_submit: 'Failed to submit soil data',
        failed_upload: 'Failed to upload file',
        data_submitted: 'Soil data submitted successfully! Generating recommendations...',
        soil_health_card: 'Soil Health Card',
        soil_health_analysis: 'Soil Health Analysis',
        parameter: 'Parameter',
        value: 'Value',
        health_score: 'Health Score',
        fertilizer_plan: 'Fertilizer Plan',
        app_schedule: 'Application Schedule',
        improvement_advisory: 'Soil Improvement Advisory',
        govt_verified: 'Govt. Verified Prices',
        total_estimate: 'TOTAL ESTIMATE',
        stage: 'Stage',
        time: 'Time',
        fertilizer: 'Fertilizer',
        quantity: 'Quantity',
        note: 'Note',
        issue: 'Soil Issue',
        recommendation: 'Recommendation',
        purpose: 'Purpose',
        price_na: 'Price N/A',
        unverified: 'Unverified / Estimated',

        // Sugarcane Management
        sugarcane_mgmt: 'Sugarcane Management',
        irrigation_status: 'Irrigation Status',
        soil_moisture: 'Soil Moisture',
        current_moisture: 'Current Soil Moisture',
        urgency: 'Urgency',
        recom_action: 'Recommended Action',
        water_need: 'Water Need',
        why_recom: 'Why is this recommended?',
        fert_splits: 'Fertilizer split doses (ICAR Co 0238)',
        est_cost: 'Est. Cost',
        advice: 'Advice',
        skip_risk_warn: 'Behavioral Warning',
        change_variety: 'Change Variety/Date',
        crop_age: 'Crop Age',
        days: 'Days',
        germination: 'Germination',
        tillering: 'Tillering',
        grand_growth: 'Grand Growth',
        maturity: 'Maturity',
        setup_title: '🎋 Sugarcane Management Setup',
        setup_desc: 'To enable real-time irrigation and nutrient demand tracking, please provide your crop details.',
        activate_dss: 'Activate Decision Support System',
        ambient_temp: 'Ambient Temperature',
        rel_humidity: 'Relative Humidity',
        wind_speed: 'Wind Speed',
        growth_progress: 'Growth Phase Progress',
        recent_rain: 'Recent Rainfall',
        phase_duration: 'Phase Duration',
        low_humidity_warn: 'Low humidity increases water stress.',
        high_wind_warn: 'High wind speed accelerates evaporation.',
        irrigation_forecast: 'Irrigation Forecast',
        pumping_cost: 'Est. Pumping Cost',
        est_next_date: 'Next Required Irrigation',
        per_ha: 'per hectare',
        soil_suitability: 'Soil Suitability',
        suitable: 'Suitable',
        marginal: 'Marginal',
        unsuitable: 'Unsuitable',
        full_cycle_requirement: 'Full Crop Cycle Requirement',
        season_requirement: 'Season Requirement',
        advisory_disclaimer: 'Quantities are advisory and subject to soil condition, crop stage, and farmer practice.',
        soil_issues: 'Soil Issues',
        moisture_data_unavailable: 'Moisture Data Not Available',
        please_enter_soil_data: 'Please enter soil data to enable irrigation recommendations',
        very_low: 'Very Low',
        low: 'Low',
        optimal: 'Optimal',
        high: 'High',
        precise_ai_recom: 'Precise AI Recommendation',
        irrigate_template: 'Irrigate {volume}mm today because {reason}',
        reason_high_evaporation: 'the high sun and wind will dry out your roots by evening.',
        reason_critical_depletion: 'soil moisture has dropped below the critical survival threshold.',
        reason_optimal_maintenance: 'it is time to maintain optimal growth for your crop.',
        reason_germination_sensitivity: 'the seeds are in the sensitive germination stage and need stable moisture.',
        reason_tillering_critical: 'the crop is forming tillers and any stress now will reduce your final yield.',
        excessive_moisture: 'Excessive Moisture',
        fert_schedule: 'Fertilizer Schedule',
        basal: 'Basal',
        pre_maturity: 'Pre-maturity',
        crop_quality_test: 'Crop Quality Test',
        select_crop: 'Select Crop',
        upload_harvest_images: 'Upload Harvest Images',
        analyze_quality: 'Analyze Quality',
        quality_assessment: 'Harvest Quality Assessment',
        est_grade: 'Estimated Grade',
        sugar_potential: 'Sugar Quality Potential',
        maturity_assessment: 'Maturity Status',
        download_report: 'Download Detailed PDF Report',
        ai_observations: 'AI Visual Observations',
        visual_traits: 'Physical Traits Detected',
        what_this_means: 'What this means for you',
        sugar_recovery_impact: 'Sugar Recovery Impact',
        price_deduction_risk: 'Price Deduction Risk',
        next_steps_advice: 'Harvest & Ratoon Advice',
        visual_stress_highlights: 'Detected Stress Regions',
        high_quality_encourage: 'Excellent! Your crop management has resulted in premium harvest quality.',
        stalk_thickness: 'Stalk Thickness',
        color_uniformity: 'Color Uniformity',
        internode_spacing: 'Internode Spacing',
        quality_high_desc: 'Excellent harvest quality. Optimal sucrose accumulation expected.',
        quality_med_desc: 'Good harvest. Minor stress symptoms visible.',
        quality_low_desc: 'Sub-optimal quality. Signs of disease or waterlogging impact.',
    },
    hi: {
        dashboard: 'डैशबोर्ड',
        quick_actions: 'त्वरित कार्रवाई',
        system_features: 'सिस्टम सुविधाएँ',
        register_farmer: 'नया किसान पंजीकरण',
        recent_farmers: 'हाल के किसान',

        iot_integration: 'IoT एकीकरण',
        iot_integration_desc: 'रीयल-टाइम मिट्टी सेंसर',
        ml_recommendations: 'ML सिफारिशें',
        ml_recommendations_desc: 'AI-संचालित उर्वरक सुझाव',
        soil_health_cards: 'मृदा स्वास्थ्य कार्ड',
        soil_health_cards_desc: 'सरकारी-सत्यापित रिपोर्ट',
        dealer_locator: 'डीलर खोजक',
        dealer_locator_desc: 'निकटतम उर्वरक दुकानें खोजें',
        subsidy_calc: 'सब्सिडी कैलकुलेटर',
        subsidy_calc_desc: 'सरकारी सब्सिडी की गणना करें',
        govt_integration: 'सरकारी योजनाएं (Govt. Schemes)',
        govt_integration_desc: 'भारत सरकार मृदा स्वास्थ्य कार्ड मानक',
        multi_dataset: 'मल्टी-डेटासेट AI',
        multi_dataset_desc: '30,000+ अखिल भारतीय नमूनों पर प्रशिक्षण',
        coming_soon: 'जल्द आ रहा है',

        // New Pages
        farmer: 'किसान',
        crop: 'फसल',
        soil_data_entry: 'मृदा डेटा प्रविष्टि',
        back_dashboard: 'डैशबोर्ड पर वापस जाएं',
        manual_entry: 'मैनुअल प्रविष्टि',
        upload_file: 'फ़ाइल अपलोड करें',
        submit_generate: 'जमा करें और सिफारिशें प्राप्त करें',
        drag_drop: 'फ़ाइल यहाँ खींचें या क्लिक करें',
        drop_file: 'फ़ाइल यहाँ छोड़ें',
        uploading: 'अपलोड हो रहा है',
        failed_load_farmer: 'किसान विवरण लोड करने में विफल',
        failed_submit: 'डेटा जमा करने में विफल',
        failed_upload: 'फ़ाइल अपलोड करने में विफल',
        data_submitted: 'डेटा सफलतापूर्वक जमा किया गया!',
        soil_health_card: 'मृदा स्वास्थ्य कार्ड',
        soil_health_analysis: 'मृदा स्वास्थ्य विश्लेषण',
        parameter: 'पैरामीटर',
        value: 'मान',
        health_score: 'स्वास्थ्य स्कोर',
        fertilizer_plan: 'उर्वरक योजना',
        app_schedule: 'आवेदन अनुसूची',
        improvement_advisory: 'सुधार सलाह',
        govt_verified: 'सरकारी सत्यापित मूल्य',
        total_estimate: 'कुल अनुमान',
        stage: 'चरण',
        time: 'समय',
        fertilizer: 'उर्वरक',
        quantity: 'मात्रा',
        note: 'नोट',
        issue: 'समस्या',
        recommendation: 'सिफारिश',
        purpose: 'उद्देश्य',
        price_na: 'मूल्य उपलब्ध नहीं',
        unverified: 'असत्यापित / अनुमानित',

        // Sugarcane Management
        sugarcane_mgmt: 'गन्ना प्रबंधन',
        irrigation_status: 'सिंचाई की स्थिति',
        soil_moisture: 'मिट्टी की नमी',
        current_moisture: 'वर्तमान मिट्टी की नमी',
        urgency: 'अत्यावश्यकता',
        recom_action: 'सिफारिश की गई कार्रवाई',
        water_need: 'पानी की आवश्यकता',
        why_recom: 'यह क्यों अनुशंसित है?',
        fert_splits: 'उर्वरक विभाजन खुराक (ICAR Co 0238)',
        est_cost: 'अनुमानित लागत',
        advice: 'सलाह',
        skip_risk_warn: 'व्यवहार संबंधी चेतावनी',
        change_variety: 'विविधता/तारीख बदलें',
        crop_age: 'फसल की आयु',
        days: 'दिन',
        germination: 'अंकुरण',
        tillering: 'कल्ले निकलना',
        grand_growth: 'मुख्य वृद्धि',
        maturity: 'परिपक्वता',
        setup_title: '🎋 गन्ना प्रबंधन सेटअप',
        setup_desc: 'रीयल-टाइम सिंचाई और पोषक तत्वों की मांग पर नज़र रखने के लिए, कृपया अपनी फसल का विवरण प्रदान करें।',
        activate_dss: 'निर्णय समर्थन प्रणाली सक्रिय करें',
        ambient_temp: 'परिवेश का तापमान',
        rel_humidity: 'सापेक्ष आर्द्रता',
        wind_speed: 'हवा की गति',
        growth_progress: 'फसल वृद्धि चरण प्रगति',
        recent_rain: 'हाल की बारिश',
        phase_duration: 'चरण की अवधि',
        low_humidity_warn: 'कम आर्द्रता पानी के तनाव को बढ़ाती है।',
        high_wind_warn: 'हवा की तेज़ गति वाष्पीकरण को बढ़ाती है।',
        irrigation_forecast: 'सिंचाई का पूर्वानुमान',
        pumping_cost: 'अनुमानित पम्पिंग लागत',
        est_next_date: 'अगली आवश्यक सिंचाई',
        per_ha: 'प्रति हेक्टेयर',
        soil_suitability: 'मिट्टी की उपयुक्तता',
        suitable: 'उपयुक्त',
        marginal: 'सीमांत',
        unsuitable: 'अनुपयुक्त',
        full_cycle_requirement: 'पूर्ण फसल चक्र आवश्यकता',
        season_requirement: 'मौसम की आवश्यकता',
        advisory_disclaimer: 'मात्राएं सलाहकारी हैं और मिट्टी की स्थिति, फसल के चरण और किसान अभ्यास के अधीन हैं।',
        soil_issues: 'मिट्टी की समस्याएं',
        moisture_data_unavailable: 'नमी का डेटा उपलब्ध नहीं',
        please_enter_soil_data: 'सिंचाई सिफारिशों को सक्षम करने के लिए मिट्टी का डेटा दर्ज करें',
        very_low: 'बहुत कम',
        low: 'कम',
        optimal: 'इष्टतम',
        high: 'उच्च',
        precise_ai_recom: 'सटीक AI अनुशंसा',
        irrigate_template: 'आज {volume} मिमी सिंचाई करें क्योंकि {reason}',
        reason_high_evaporation: 'तेज धूप और हवा शाम तक आपकी जड़ों को सुखा देगी।',
        reason_critical_depletion: 'मिट्टी की नमी महत्वपूर्ण उत्तरजीविता सीमा से नीचे गिर गई है।',
        reason_optimal_maintenance: 'आपकी फसल के इष्टतम विकास को बनाए रखने का समय आ गया है।',
        reason_germination_sensitivity: 'बीज संवेदनशील अंकुरण चरण में हैं और उन्हें स्थिर नमी की आवश्यकता है।',
        reason_tillering_critical: 'फसल कल्ले (tillers) बना रही है और अभी कोई भी तनाव आपकी अंतिम उपज को कम कर देगा।',
        excessive_moisture: 'अत्यधिक नमी',
        fert_schedule: 'उर्वरक अनुसूची',
        basal: 'मूल खुराक (Basal)',
        pre_maturity: 'परिपक्वता पूर्व',
        crop_quality_test: 'फसल गुणवत्ता परीक्षण',
        select_crop: 'फसल चुनें',
        upload_harvest_images: 'कटाई की तस्वीरें अपलोड करें',
        analyze_quality: 'गुणवत्ता का विश्लेषण करें',
        quality_assessment: 'फसल गुणवत्ता मूल्यांकन',
        est_grade: 'अनुमानित ग्रेड',
        sugar_potential: 'चीनी गुणवत्ता क्षमता',
        maturity_assessment: 'परिपक्वता की स्थिति',
        download_report: 'विस्तृत PDF रिपोर्ट डाउनलोड करें',
        ai_observations: 'AI दृश्य अवलोकन',
        visual_traits: 'पता चले शारीरिक लक्षण',
        what_this_means: 'आपके लिए इसका क्या मतलब है',
        sugar_recovery_impact: 'चीनी की रिकवरी पर प्रभाव',
        price_deduction_risk: 'कीमत में कटौती का जोखिम',
        next_steps_advice: 'कटाई और पेड़ी (Ratoon) सलाह',
        visual_stress_highlights: 'तनाव के चिह्नित क्षेत्र',
        high_quality_encourage: 'उत्कृष्ट! आपके प्रबंधन के परिणामस्वरूप प्रीमियम फसल की गुणवत्ता प्राप्त हुई है।',
        stalk_thickness: 'डंठल की मोटाई',
        color_uniformity: 'रंग की समानता',
        internode_spacing: 'पोरियों के बीच की दूरी',
        quality_high_desc: 'उत्कृष्ट गुणवत्ता। अधिक चीनी प्राप्ति की संभावना।',
        quality_med_desc: 'ठीक-ठाक गुणवत्ता। कुछ तनाव के लक्षण दिख रहे हैं।',
        quality_low_desc: 'कम गुणवत्ता। बीमारी या जलभराव का असर दिख रहा है।',
    },
    bn: {
        dashboard: 'ড্যাশবোর্ড',
        quick_actions: 'দ্রুত কর্ম',
        system_features: 'সিস্টেম বৈশিষ্ট্য',
        register_farmer: 'নতুন কৃষক নিবন্ধন',
        recent_farmers: 'সাম্প্রতিক কৃষক',

        iot_integration: 'IoT ইন্টিগ্রেশন',
        iot_desc: 'রিয়েল-টাইম মাটি সেন্সর',
        ml_recommendations: 'ML সুপারিশ',
        ml_desc: 'AI-চালিত সার পরামর্শ',
        soil_health_cards: 'মাটির স্বাস্থ্য কার্ড',
        shc_desc: 'সরকার-যাচাইকৃত রিপোর্ট',
        dealer_locator: 'ডিলার খুঁজুন',
        dealer_desc: 'নিকটতম সার দোকান খুঁজুন',
        subsidy_calc: 'ভর্তুকি ক্যালকুলেটর',
        subsidy_desc: 'সরকারী ভর্তুকি গণনা করুন',
        govt_integration: 'সরকারি ইন্টিগ্রেশন',
        govt_desc: 'PM-KISAN ও মাটির স্বাস্থ্য মিশন',
        coming_soon: 'শীঘ্রই আসছে',
    },
    te: {
        dashboard: 'డాష్‌బోర్డ్',
        quick_actions: 'త్వరిత చర్యలు',
        system_features: 'సిస్టమ్ ఫీచర్లు',
        register_farmer: 'కొత్త రైతు నమోదు',
        recent_farmers: 'ఇటీవలి రైతులు',

        iot_integration: 'IoT ఇంటిగ్రేషన్',
        iot_desc: 'రియల్-టైమ్ నేల సెన్సార్లు',
        ml_recommendations: 'ML సిఫార్సులు',
        ml_desc: 'AI-ఆధారిత ఎరువుల సూచనలు',
        soil_health_cards: 'నేల ఆరోగ్య కార్డులు',
        shc_desc: 'ప్రభుత్వ-ధృవీకరించిన నివేదికలు',
        dealer_locator: 'డీలర్ లొకేటర్',
        dealer_desc: 'సమీప ఎరువుల దుకాణాలను కనుగొనండి',
        subsidy_calc: 'సబ్సిడీ కాలిక్యులేటర్',
        subsidy_desc: 'ప్రభుత్వ సబ్సిడీని లెక్కించండి',
        govt_integration: 'ప్రభుత్వ ఇంటిగ్రేషన్',
        govt_desc: 'PM-KISAN & నేల ఆరోగ్య మిషన్',
        coming_soon: 'త్వరలో వస్తోంది',
    },
    mr: {
        dashboard: 'डॅशबोर्ड',
        quick_actions: 'द्रुत कृती',
        system_features: 'सिस्टम वैशिष्ट्ये',
        register_farmer: 'नवीन शेतकरी नोंदणी',
        recent_farmers: 'अलीकडील शेतकरी',

        iot_integration: 'IoT एकत्रीकरण',
        iot_desc: 'रिअल-टाइम माती सेन्सर',
        ml_recommendations: 'ML शिफारसी',
        ml_desc: 'AI-आधारित खत सूचना',
        soil_health_cards: 'माती आरोग्य कार्ड',
        shc_desc: 'सरकार-सत्यापित अहवाल',
        dealer_locator: 'डीलर शोधक',
        dealer_desc: 'जवळचे खत दुकाने शोधा',
        subsidy_calc: 'सबसिडी कॅल्क्युलेटर',
        subsidy_desc: 'सरकारी सबसिडी मोजा',
        govt_integration: 'सरकारी योजना (Govt. Schemes)',
        govt_desc: 'PM-KISAN आणि माती आरोग्य मिशन',
        coming_soon: 'लवकरच येत आहे',
        precise_ai_recom: 'अचूक AI शिफारस',
        irrigate_template: 'आज {volume} मिमी सिंचन करा कारण {reason}',
        reason_high_evaporation: 'प्रखर सूर्य आणि वाऱ्यामुळे संध्याकाळपर्यंत तुमची मुळे कोरडी होतील।',
        reason_critical_depletion: 'जमिनीतील ओलावा गंभीर पातळीच्या खाली गेला आहे।',
        reason_optimal_maintenance: 'तुमच्या पिकाची योग्य वाढ टिकवून ठेवण्याची ही वेळ आहे।',
        reason_germination_sensitivity: 'बियाणे संवेदनशील अंकुरण अवस्थेत आहेत आणि त्यांना स्थिर ओलाव्याची गरज आहे।',
        reason_tillering_critical: 'पिकाला फुटवे (tillers) फुटत आहेत आणि आता कोणताही ताण तुमच्या अंतिम उत्पादनात घट करेल।',
        excessive_moisture: 'अत्यधिक ओलावा',
        fert_schedule: 'खत वेळापत्रक',
        basal: 'पायाभूत मात्रा (Basal)',
        tillering: 'फुटवे फुटणे',
        grand_growth: 'मुख्य वाढ',
        pre_maturity: 'पक्वता पूर्व',
        crop_quality_test: 'पीक गुणवत्ता चाचणी',
        select_crop: 'पीक निवडा',
        upload_harvest_images: 'काढणीची छायाचित्रे अपलोड करा',
        analyze_quality: 'गुणवत्तेचे विश्लेषण करा',
        quality_assessment: 'पीक गुणवत्ता मूल्यमापन',
        est_grade: 'अंदाजित श्रेणी (Grade)',
        sugar_potential: 'साखर गुणवत्ता क्षमता',
        maturity_assessment: 'पक्वतेची स्थिती',
        download_report: 'तपशीलवार PDF अहवाल डाउनलोड करा',
        ai_observations: 'AI दृश्य निरीक्षणे',
        visual_traits: 'आढळलेली शारीरिक वैशिष्ट्ये',
        what_this_means: 'तुमच्यासाठी याचे काय महत्त्व आहे',
        sugar_recovery_impact: 'साखर रिकव्हरीवर परिणाम',
        price_deduction_risk: 'किंमत कपातीचा धोका',
        next_steps_advice: 'कापणी आणि खोडवा (Ratoon) सल्ला',
        visual_stress_highlights: 'ताणतणाव आढळलेले भाग',
        high_quality_encourage: 'उत्कृष्ट! तुमच्या नियोजनामुळे प्रीमियम पिकाची गुणवत्ता प्राप्त झाली आहे।',
        stalk_thickness: 'कांड्याची जाडी',
        color_uniformity: 'रंगाची समानता',
        internode_spacing: 'कांड्यांमधील अंतर',
        quality_high_desc: 'उत्कृष्ट गुणवत्ता. जास्तीत जास्त साखर मिळण्याची शक्यता.',
        quality_med_desc: 'चांगली गुणवत्ता. काही प्रमाणात ताण दिसत आहे.',
        quality_low_desc: 'अल्प गुणवत्ता. रोग किंवा अति पाण्याचा परिणाम दिसत आहे.',
    },
    ta: {
        dashboard: 'முகப்புப் பலகை',
        quick_actions: 'விரைவு செயல்கள்',
        system_features: 'அமைப்பு அம்சங்கள்',
        register_farmer: 'புதிய விவசாயி பதிவு',
        recent_farmers: 'சமீபத்திய விவசாயிகள்',

        iot_integration: 'IoT ஒருங்கிணைப்பு',
        iot_desc: 'நேரடி மண் உணரிகள்',
        ml_recommendations: 'ML பரிந்துரைகள்',
        ml_desc: 'AI-இயக்கப்படும் உர பரிந்துரைகள்',
        soil_health_cards: 'மண் சுகாதார அட்டைகள்',
        shc_desc: 'அரசு-சரிபார்க்கப்பட்ட அறிக்கைகள்',
        dealer_locator: 'டீலர் கண்டுபிடிப்பு',
        dealer_desc: 'அருகிலுள்ள உர கடைகளைக் கண்டறியவும்',
        subsidy_calc: 'மானியம் கணக்கெடுப்பு',
        subsidy_desc: 'அரசு மானியத்தைக் கணக்கிடுங்கள்',
        govt_integration: 'அரசு ஒருங்கிணைப்பு',
        govt_desc: 'PM-KISAN & மண் சுகាதார திட்டம்',
        coming_soon: 'விரைவில் வருகிறது',
    },
    gu: {
        dashboard: 'ડેશબોર્ડ',
        quick_actions: 'ઝડપી ક્રિયાઓ',
        system_features: 'સિસ્ટમ સુવિધાઓ',
        register_farmer: 'નવા ખેડૂતની નોંધણી',
        recent_farmers: 'તાજેતરના ખેડૂતો',

        iot_integration: 'IoT એકીકરણ',
        iot_desc: 'રિયલ-ટાઇમ માટી સેન્સર્સ',
        ml_recommendations: 'ML ભલામણો',
        ml_desc: 'AI-સંચાલિત ખાતર સૂચનો',
        soil_health_cards: 'માટી આરોગ્ય કાર્ડ',
        shc_desc: 'સરકાર-ચકાસાયેલ રિપોર્ટ્સ',
        dealer_locator: 'ડીલર શોધક',
        dealer_desc: 'નજીકની ખાતર દુકાનો શોધો',
        subsidy_calc: 'સબસિડી કેલ્ક્યુલેટર',
        subsidy_desc: 'સરકારી સબસિડીની ગણતરી કરો',
        govt_integration: 'સરકારી એકીકરણ',
        govt_desc: 'PM-KISAN અને માટી આરોગ્ય મિશન',
        coming_soon: 'જલદી આવી રહ્યું છે',
    },
    kn: {
        dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
        quick_actions: 'ತ್ವರಿತ ಕ್ರಿಯೆಗಳು',
        system_features: 'ವ್ಯವಸ್ಥೆ ವೈಶಿಷ್ಟ್ಯಗಳು',
        register_farmer: 'ಹೊಸ ರೈತ ನೋಂದಣಿ',
        recent_farmers: 'ಇತ್ತೀಚಿನ ರೈತರು',

        iot_integration: 'IoT ಏಕೀಕರಣ',
        iot_desc: 'ನೈಜ-ಸಮಯ ಮಣ್ಣಿನ ಸಂವೇದಕಗಳು',
        ml_recommendations: 'ML ಶಿಫಾರಸುಗಳು',
        ml_desc: 'AI-ಚಾಲಿತ ರಸಗೊಬ್ಬರ ಸಲಹೆಗಳು',
        soil_health_cards: 'ಮಣ್ಣಿನ ಆರೋಗ್ಯ ಕಾರ್ಡ್‌ಗಳು',
        shc_desc: 'ಸರ್ಕಾರ-ಪರಿಶೀಲಿಸಿದ ವರದಿಗಳು',
        dealer_locator: 'ಡೀಲರ್ ಲೊಕೇಟರ್',
        dealer_desc: 'ಹತ್ತಿರದ ರಸಗೊಬ್ಬರ ಅಂಗಡಿಗಳನ್ನು ಹುಡುಕಿ',
        subsidy_calc: 'ಸಬ್ಸಿಡಿ ಕ್ಯಾಲ್ಕುಲೇಟರ್',
        subsidy_desc: 'ಸರ್ಕಾರಿ ಸಬ್ಸಿಡಿಯನ್ನು ಲೆಕ್ಕಹಾಕಿ',
        govt_integration: 'ಸರ್ಕಾರಿ ಏಕೀಕರಣ',
        govt_desc: 'PM-KISAN ಮತ್ತು ಮಣ್ಣಿನ ಆರೋಗ್ಯ ಮಿಷನ್',
        coming_soon: 'ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ',
    },
    ml: {
        dashboard: 'ഡാഷ്ബോർഡ്',
        quick_actions: 'ദ്രുത പ്രവർത്തനങ്ങൾ',
        system_features: 'സിസ്റ്റം സവിശേഷതകൾ',
        register_farmer: 'പുതിയ കര്‍ഷക രജിസ്ട്രേഷന്‍',
        recent_farmers: 'സമീപകാല കർഷകർ',

        iot_integration: 'IoT സംയോജനം',
        iot_desc: 'തത്സമയ മണ്ണ് സെൻസറുകൾ',
        ml_recommendations: 'ML ശുപാർശകൾ',
        ml_desc: 'AI-പ്രവർത്തിപ്പിച്ച വളം നിർദ്ദേശങ്ങൾ',
        soil_health_cards: 'മണ്ണ് ആരോഗ്യ കാർഡുകൾ',
        shc_desc: 'സർക്കാർ-പരിശോധിച്ച റിപ്പോർട്ടുകൾ',
        dealer_locator: 'ഡീലർ ലൊക്കേറ്റർ',
        dealer_desc: 'അടുത്തുള്ള വളം കടകൾ കണ്ടെത്തുക',
        subsidy_calc: 'സബ്സിഡി കാൽക്കുലേറ്റർ',
        subsidy_desc: 'സർക്കാർ സബ്സിഡി കണക്കാക്കുക',
        govt_integration: 'സർക്കാർ സംയോജനം',
        govt_desc: 'PM-KISAN & മണ്ണ് ആരോഗ്യ മിഷൻ',
        coming_soon: 'ഉടൻ വരുന്നു',
    },
    pa: {
        dashboard: 'ਡੈਸ਼ਬੋਰਡ',
        quick_actions: 'ਤੇਜ਼ ਕਾਰਵਾਈਆਂ',
        system_features: 'ਸਿਸਟਮ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ',
        register_farmer: 'ਨਵਾਂ ਕਿਸਾਨ ਰਜਿਸਟਰੇਸ਼ਨ',
        recent_farmers: 'ਹਾਲੀਆ ਕਿਸਾਨ',

        iot_integration: 'IoT ਏਕੀਕਰਣ',
        iot_desc: 'ਰੀਅਲ-ਟਾਈਮ ਮਿੱਟੀ ਸੈਂਸਰ',
        ml_recommendations: 'ML ਸਿਫਾਰਸ਼ਾਂ',
        ml_desc: 'AI-ਸੰਚਾਲਿਤ ਖਾਦ ਸੁਝਾਅ',
        soil_health_cards: 'ਮਿੱਟੀ ਸਿਹਤ ਕਾਰਡ',
        shc_desc: 'ਸਰਕਾਰੀ-ਤਸਦੀਕ ਸ਼ੁਦਾ ਰਿਪੋਰਟਾਂ',
        dealer_locator: 'ਡੀਲਰ ਖੋਜਕ',
        dealer_desc: 'ਨਜ਼ਦੀਕੀ ਖਾਦ ਦੁਕਾਨਾਂ ਲੱਭੋ',
        subsidy_calc: 'ਸਬਸਿਡੀ ਕੈਲਕੁਲੇਟਰ',
        subsidy_desc: 'ਸਰਕਾਰੀ ਸਬਸਿਡੀ ਦੀ ਗਣਨਾ ਕਰੋ',
        govt_integration: 'ਸਰਕਾਰੀ ਏਕੀਕਰਣ',
        govt_desc: 'PM-KISAN ਅਤੇ ਮਿੱਟੀ ਸਿਹਤ ਮਿਸ਼ਨ',
        coming_soon: 'ਜਲਦੀ ਆ ਰਿਹਾ ਹੈ',
    },
    or: {
        dashboard: 'ଡ୍ୟାଶବୋର୍ଡ',
        quick_actions: 'ଶୀଘ୍ର କାର୍ଯ୍ୟ',
        system_features: 'ସିଷ୍ଟମ ବୈଶିଷ୍ଟ୍ୟ',
        register_farmer: 'ନୂତନ କୃଷକ ପଞ୍ଜୀକରଣ',
        recent_farmers: 'ସାମ୍ପ୍ରତିକ କୃଷକ',

        iot_integration: 'IoT ଏକୀକରଣ',
        iot_desc: 'ରିଅଲ-ଟାଇମ ମାଟି ସେନ୍ସର',
        ml_recommendations: 'ML ସୁପାରିଶ',
        ml_desc: 'AI-ଚାଳିତ ସାର ପରାମର୍ଶ',
        soil_health_cards: 'ମାଟି ସ୍ୱାସ୍ଥ୍ୟ କାର୍ଡ',
        shc_desc: 'ସରକାରୀ-ଯାଞ୍ଚିତ ରିପୋର୍ଟ',
        dealer_locator: 'ଡିଲର ଖୋଜକ',
        dealer_desc: 'ନିକଟସ୍ଥ ସାର ଦୋକାନ ଖୋଜନ୍ତୁ',
        subsidy_calc: 'ସବସିଡି କାଲ୍କୁଲେଟର',
        subsidy_desc: 'ସରକାରୀ ସବସିଡି ଗଣନା କରନ୍ତୁ',
        govt_integration: 'ସରକାରୀ ଏକୀକରଣ',
        govt_desc: 'PM-KISAN ଏବଂ ମାଟି ସ୍ୱାସ୍ଥ୍ୟ ମିଶନ',
        coming_soon: 'ଶୀଘ୍ର ଆସୁଛି',
    },

};

export function getText(key, lang = 'en') {
    return TRANSLATIONS[lang]?.[key] || TRANSLATIONS.en[key] || key;
}
